import moment from 'moment'

const composeCsvFilename = (filters, title, customDisplayName) => {
  const composeDateRange = () =>
    ` ${moment(filters.startDate).format('YYYY-MM-DD')} - ${moment(filters.endDate).format(
      'YYYY-MM-DD'
    )}`

  return `${customDisplayName || 'Balto'} ${title}${filters ? composeDateRange() : ''}.csv`
}

const clickDownloadLink = (href, filename) => {
  const link = document.createElement('a')
  link.className = 'download-csv'
  link.setAttribute('href', href)
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * Download an already-built CSV that lives in a Blob, via its object URL.
 *
 * exportCsv below inlines the whole file into a `data:` URI, which caps out
 * well below the size of a real scorecard export (a 13-day org 7656 export is
 * ~60MB). Streamed exports keep the server's CSV as a Blob and come through
 * here instead, so nothing large is ever held as a string.
 */
export const exportCsvFromUrl = (blobUrl, filters, title, customDisplayName) => {
  const filename = composeCsvFilename(filters, title, customDisplayName)
  clickDownloadLink(blobUrl, filename)

  return `CSV file named ${filename} downloaded successfully`
}

export const exportCsv = (csvData, filters, title, customDisplayName) => {
  // Need to replace #'s with %23. If we don't the URL gets cut off and the rest of the CSV is missing when downloaded.
  const encodedUri = encodeURI(`data:text/csv;charset=utf-8,${csvData}`).replace(/#/g, '%23')
  const filename = composeCsvFilename(filters, title, customDisplayName)

  clickDownloadLink(encodedUri, filename)

  return `CSV file named ${filename} downloaded successfully`
}
